module.exports = __webpack_public_path__ + "img/infoExpert.ac2f137d.webp";